import _ from 'lodash'
import env from 'src/env'
import { getHttpInit } from 'src/utils/api'

export async function getInvoiceReportApiCallInfo(data) {
  const {
    invoiceNo,
    fruitful_account_id,
    isPreBill,
    isAdjustment,
    dates,
    isMultiAccount,
    isAdminSnapshot,
  } = data
  const [region, accountId] = fruitful_account_id.split('-')
  let datesQuery = ''
  if (!_.isEmpty(dates?.start) && !_.isEmpty(dates?.end)) {
    datesQuery = `&start=${dates.start.format('YYYY-MM-DD')}&end=${dates.end.format('YYYY-MM-DD')}`
  }
  if (_.isEmpty(fruitful_account_id) || (_.isEmpty(invoiceNo) && _.isEmpty(datesQuery))) {
    return Promise.reject('Missing Invoice Parameters')
  }
  let url = `${env.API_URL}/api/reports/${
    invoiceNo ? `invoice/${invoiceNo}/` : `account/${accountId}/`
  }?region=${region}&accountId=${accountId}`
  if (invoiceNo) {
    url += `${isPreBill ? '&isPreBill=true' : ''}${
      isAdjustment ? '&isAdjustmentBreakdown=true' : ''
    }`
  } else {
    if (!_.isEmpty(datesQuery)) {
      url += `${datesQuery}`
    }
    if (isMultiAccount) {
      url += `&isMultiAccount=true`
    }
    if (isAdminSnapshot) {
      url += `&isAdminSnapshot=true`
    }
    if (isPreBill) {
      url += `&isPreBill=true`
    }
  }
  let init = getHttpInit('GET')
  const response = await fetch(url, init)
  return response
}
